import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

import { getGradientBorderStyles } from '../styles/gradientBorderStyles';

export interface IMplRadioButtonWithDatesStyledProps {
	disabled?: boolean;
}

export interface IStyledRadioButtonWithDatesContainerProps
	extends IMplRadioButtonWithDatesStyledProps {
	checked?: boolean;
	compact?: boolean;
}

export const StyledRadioButtonWithDatesContainer = styled(Stack, {
	shouldForwardProp: (prop) =>
		prop !== 'disabled' && prop !== 'checked' && prop !== 'compact',
})<IStyledRadioButtonWithDatesContainerProps>(
	({ theme, disabled, checked, compact }) => ({
		width: '100%',
		height: compact ? '64px' : '85px',
		boxSizing: 'border-box',
		position: 'relative',
		border:
			checked && !disabled
				? 'none'
				: `0.5px solid ${
						disabled
							? theme.palette.solutions?.[100]
							: theme.palette.solutions?.[600]
				  }`,
		borderRadius: '8px',
		flexDirection: 'row',
		alignItems: 'center',
		paddingLeft: '12px',
		paddingRight: '12px',
		cursor: disabled ? 'not-allowed' : 'pointer',
		backgroundColor: 'transparent',
		opacity: disabled ? 0.4 : 1,
		boxShadow: checked ? '0px 4px 6px 0px rgba(24, 39, 75, 0.12)' : 'none',
		transition:
			'border-color 0.2s ease, opacity 0.2s ease, box-shadow 0.2s ease',
		'&:hover': {
			borderColor: disabled
				? theme.palette.solutions?.[100]
				: theme.palette.solutions?.[600],
		},
		...(checked && !disabled && getGradientBorderStyles(theme)),
	})
);

export const StyledDatesStack = styled(Stack, {
	shouldForwardProp: (prop) => prop !== 'compact',
})<{ compact?: boolean }>(({ theme, compact }) => ({
	gap: theme.spacing(compact ? 0 : 0.25),
	marginTop: theme.spacing(compact ? 0 : 0.25),
}));
